import React from 'react';
import TextField from '@material-ui/core/TextField';
import { isEmpty,isUndefined } from 'lodash'
import IntlMessages from 'util/IntlMessages';
import {useSelector} from 'react-redux'
function SelectKontokt(props) {
    const [Kontokt,setKontokt]=React.useState(props.Kontokt)
    const Flags = useSelector(state=>state.accountsData.Flags) 
    console.log(props,"props in SelectKontokt")
    React.useEffect(()=>{
        setKontokt(props.Kontokt)
    },[props.Kontakter])
    const onChangeHanle=(e)=>{
        if(parseInt(e.target.value) !== 0){
            let currentKontakt = props.Kontakter.filter((n)=>{
                return n.id === parseInt(e.target.value)
            })
            console.log(currentKontakt,"ASD")
            if(isEmpty(currentKontakt)){
                let kontkat={
                    id:0,
                    FirstName:"",
                    LastName:"",
                    Email:"",
                    Tele:"",
                    Role:"",
                    PersonNr:""
                }
                setKontokt(kontkat)
                props.onchangeHanelKontakt(kontkat)
            }
            else{
            let kontkat={
                id:currentKontakt[0].id,
                FirstName:currentKontakt[0].fname,
                LastName:currentKontakt[0].lname,
                Email:currentKontakt[0].Email,
                Tele:isEmpty(currentKontakt[0].Tele)?"":TeleFormat(currentKontakt[0].Tele),
                Role:isEmpty(currentKontakt[0].Role)?"":TeleFormat(currentKontakt[0].Role),
                PersonNr:isEmpty(currentKontakt[0].PersonNr)?"":currentKontakt[0].PersonNr,
            }
            setKontokt(kontkat)
            props.onchangeHanelKontakt(kontkat)
            }
        }else{
            let kontkat={
                id:0,
                FirstName:"",
                LastName:"",
                Email:"",
                Tele:"",
                Role:"",
                PersonNr:""
            }
            setKontokt(kontkat)
            props.onchangeHanelKontakt(kontkat)
        }
        
    }
    const TeleFormat=(Tele)=>{
        let LandCode = Flags.BolagData === "NO"?"+47":"+46"
        Tele = String(Tele).replace(/[^\d+]+/g,'')
        Tele = Tele.split(" ").join("")
        Tele = Tele.split("-").join("")
        let Tele1=''
        if(parseInt(Tele[0]) === 0){
            Tele = Tele.substring(1)
          }
        let Tele2=Tele
        switch(true){
            case Tele[0] === '+':
                Tele2=`${Tele}`
                break;
            case Tele.length < 10:
                Tele2=`${LandCode}${Tele}`
                break;
            case Tele.length < 11:
                Tele1 = Tele.substring(1)
                Tele2=`${LandCode}${Tele1}`
                break;
            case Tele.length < 12:
                Tele1 = Tele.substring(2)
                Tele2=`${LandCode}${Tele1}`
                break;
            case Tele.length < 13:
                if(Tele[0] === "+"){
                    Tele2=`${Tele}`
                }else{
                    Tele1 = Tele.substring(3)
                    Tele2=`${LandCode}${Tele1}`
                }                
                break;
            case Tele.length < 14:
                    Tele1 = Tele.substring(2)
                    Tele2=`+${Tele1}`
                break;
                default:Tele2=Tele
        }
        return Tele2
    }
    return (
        <div>
          <TextField
           fullWidth
           select
        //    error={Kontokt.id === ""}
           variant="outlined"
           size="small"
           name="title"
           label={<IntlMessages id="Contacter.Choose"/>}
           value={Kontokt.id}
           SelectProps={{native: true,}}
           disabled={isUndefined(props.isDisabled)?false:props.isDisabled}
           error={(isUndefined(props.isRequired)?"":props.Kontokt.FirstName === "") || props.error}
           InputLabelProps={{ shrink: true }}
           onChange={onChangeHanle}
           >
               <option value="" ><IntlMessages id="Choose"/></option>
               <option value="0" ><IntlMessages id="appKontoModule.Create.new"/></option>
               {
                   !isEmpty(props.Kontakter)?
               props.Kontakter.map((option) => (
                    <option key={option.id} value={option.id}>
                        {option.fname} {option.lname}
                    </option>
                )):""
                }
           </TextField>  
        </div>
    );
}

export default SelectKontokt